// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TooltipPresentationProps } from "@flip/MobiusOverrides/Tooltip/Tooltip";
import HelpCircle from "@flip/XDL/Icons/HelpCircle";
import { fontConfig } from "@flip/XDL/PreStyle/typography";
import { xBaseTheme } from "@flip/XDL/types";
import { color, styledScrollbar } from "@flip/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        cssOverrides: {
            container: {
                lineHeight: 0,
            },
            tooltipContainer: css`
                background-color: ${color("common.ui1")};
                box-shadow: 0 2px 4px 0 ${color("common.ui7", 0.1)};
                padding: 12px;
                max-width: 300px;
                border: 1px solid ${color("common.border")};
                border-radius: 6px;
                background-color: ${color("common.ui1")};
                min-width: 140px;

                &[data-placement^="top"] > .tippy-arrow {
                    bottom: -10px;
                    &:before {
                        transform: rotate(45deg);
                    }
                }

                &[data-placement^="bottom"] > .tippy-arrow {
                    top: -10px;
                    &:before {
                        transform: rotate(-135deg);
                    }
                }

                &[data-placement^="left"] > .tippy-arrow {
                    right: -9px;
                    &:before {
                        transform: rotate(-45deg);
                    }
                }

                &[data-placement^="right"] > .tippy-arrow {
                    left: -9px;
                    top: 10px;
                    &:before {
                        transform: rotate(135deg);
                    }
                }

                .tippy-arrow,
                .tippy-arrow::before {
                    position: absolute;
                    width: 20px;
                    height: 20px;
                    z-index: 1;
                }

                .tippy-arrow::before {
                    content: "";
                    background: ${color("common.ui1")};
                    border-color: ${color("common.border")};
                    border-style: solid;
                    border-width: 0 1px 1px 0;
                    border-bottom-right-radius: 6px;
                }

                ${styledScrollbar(2)}
            `,
            tooltipBody: css`
                display: flex;
                flex-direction: column;
                flex: 0 0 auto;
            `,
            tooltipClickable: css`
                margin-left: 5px;
                margin-right: 5px;
            `,
        } as TooltipPresentationProps,
        iconProps: {
            src: HelpCircle,
            size: 16,
            color: "secondary",
            css: css``,
        },
        typographyProps: {
            size: 14,
            lineHeight: "22px",
            color: "text.main",
            weight: fontConfig.weight.regular,
            css: css`
                letter-spacing: 0;
                &:hover {
                    text-decoration: none;
                }
            `,
        },
    },
} as xBaseTheme["tooltip"];
